export default "__VITE_ASSET__5Een4qBC__"